import type { FC } from "react";
import { getPositiveNumber } from "../deckGeometry";
import type { SupportGraphicProps } from "../finishedDeckSectionGeometry";

export const NAG_SUPPORT_WIDTH_MM = 60;
export const NAG_SUPPORT_THICKNESS_MM = 3;

const NAG_SUPPORT_COLOR = "#333941";
const NAG_SUPPORT_EDGE_COLOR = "#171c22";

const Nag: FC<SupportGraphicProps> = ({ heightMm, unitHeightMm, widthMm, ...props }) => {
  const layerHeightMm = getPositiveNumber(unitHeightMm, NAG_SUPPORT_THICKNESS_MM);
  const layerCount = Math.max(1, Math.ceil(getPositiveNumber(heightMm, layerHeightMm) / layerHeightMm));
  const drawingHeightMm = layerCount * layerHeightMm;
  const drawingWidthMm = getPositiveNumber(widthMm, NAG_SUPPORT_WIDTH_MM);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${drawingWidthMm} ${drawingHeightMm}`}
      aria-hidden="true"
      fill="none"
      shapeRendering="geometricPrecision"
      {...props}
    >
      {Array.from({ length: layerCount }, (_, index) => {
        const y = index * layerHeightMm;

        return (
          <g key={index}>
            <rect x="0" y={y} width={drawingWidthMm} height={layerHeightMm} fill={NAG_SUPPORT_COLOR} />
            <rect
              x="0"
              y={y}
              width={drawingWidthMm}
              height={layerHeightMm}
              fill="none"
              stroke={NAG_SUPPORT_EDGE_COLOR}
              strokeWidth="0.18"
            />
          </g>
        );
      })}
    </svg>
  );
};

export default Nag;
